export const PropertyStatus = {
    AVAILABLE: "Available",
    SELECTED: "Selected",
}